<template>
  <div class="messageImport">
    <div class="messageImport-left">
      <a-form :form="form">
        <a-form-item
          label="短信标题"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入短信标题"
            v-decorator="[
              'title',
              {
                rules: [{ required: true, message: '请选择短信标题' }],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="导入文件"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-upload
            name="file"
            :multiple="true"
            accept=".xls"
            :fileList="fileList"
            :remove="handleRemove"
            :beforeUpload="beforeUpload"
            style="display: inline-block"
          >
            <a-button>
              <a-icon type="upload" />
              选择导入文件
            </a-button>
          </a-upload>
          <p
            @click="falling('短信模板')"
            style="float: right; cursor: pointer; color: #1890ff; margin: 0"
          >
            点击下载模板
          </p>
        </a-form-item>
        <a-form-item
          label="发送时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'sendType',
              {
                rules: [{ required: true, message: '请选择发送时间' }],
              },
            ]"
            placeholder="请选择发送时间"
          >
            <a-select-option
              v-for="(item, index) in sendList"
              :value="item.value"
              :key="index"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="短信通道"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="[
              'sendAisle',
              {
                rules: [{ required: true, message: '请选择短信通道' }],
              },
            ]"
            :triggerChange="true"
            placeholder="请选择短信通道"
            v-model="queryParam.sendAisle"
            dictCode="send_aisle"
          />
        </a-form-item>
      </a-form>
      <div class="drawer-bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="backLastPage"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <a-button @click="handleOk" type="primary">提交</a-button>
      </div>
    </div>
    <div class="messageImport-right" v-if="isDetail">
      <import-detailModal ref="detailModal"></import-detailModal>
    </div>
    <div class="messageImport-right messageImport-empty" v-else>
      <a-empty description="请选择导入文件！"/>
    </div>
  </div>
</template>

<script>
import { postTag, uploadAction, downFile } from '@/api/manage';
import JDate from '@/components/jeecg/JDate';
import ImportDetailModal from './importDetail.vue';

export default {
  name: 'MessageImport',
  components: {
    JDate,
    ImportDetailModal,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      sendList: [
        {
          name: '立即发送',
          value: 0,
        },
        // {
        //   name: "定时发送",
        //   value: 1,
        // }
      ],
      queryParam: {
        sendAisle: '',
        sendAisleId: 0,
      },
      appId: '',
      model: {},
      isDetail: false,
      importList: {},
      fileList: [],
      sendTime: '立即发送',
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      url: {
        add: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkInfo/save',
        edit: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkInfo/edit',
        importExcelUrl:
          process.env.VUE_APP_CMS_SMSBIZ + '/mgTkRecord/importExcel', //导入
        exportsUrl:
          process.env.VUE_APP_CMS_SMSBIZ + '/mgTkRecord/exportTemplateXls', //导出空模板
      },
    };
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
  },
  methods: {
    add() {
      this.edit();
    },
    edit(record) {
      if (record.id) {
        this.appId = record.id;
        this.isDetail = true;
        setTimeout(() => {
          this.$refs.detailModal.importList = this.importList;
          this.$refs.detailModal.getList();
        });
      }
      this.modal = record;
      this.$nextTick(() => {
        setTimeout(() => {
          this.form.setFieldsValue({
            sendType: this.modal.sendType,
            sendAisle: this.modal.sendAisle,
            title: this.modal.title,
          });
        });
      });
      if (this.modal.sendAisle == 0) {
        this.queryParam.sendAisle = '国君';
        this.queryParam.sendAisleId = this.modal.sendAisle;
      }
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          // that.confirmLoading = true;
          let formData = Object.assign(this.model, values);
          let httpurl = '';
          if (!that.appId) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
            formData.id = that.appId;
          }

          formData.sendAisle = this.queryParam.sendAisleId;
          formData.impGroupId = this.importList.impGroupId;
          formData.type = 0;
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.$emit('ok');
              // that.confirmLoading = false;
            });
        }
      });
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      setTimeout(() => {
        this.upload();
      });
      console.log(this.fileList);
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
      this.isDetail = false;
    },
    //上传
    upload() {
      let formData = new FormData();
      formData.set('file', this.fileList[0]);
      uploadAction(this.url.importExcelUrl, formData)
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.importList = res.result;
            this.isDetail = true;
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.$refs.detailModal.importList = this.importList;
          this.$refs.detailModal.getList();
          this.showDialog = false;
        });
    },
    falling(fileName) {
      console.log(222);
      downFile(this.url.exportsUrl, { selections: '' }).then((data) => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    backLastPage() {
      this.$emit('handelColse');
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
.messageImport {
  height: 100%;
}
.messageImport-left {
  position: relative;
  width: 45%;
  float: left;
  height: 100%;
  margin-right: 2%;
  background-color: white;
  padding: 14px;
}
.messageImport-right {
  position: relative;
  width: 52%;
  float: right;
  height: 100%;
  margin-right: 1%;
}
.messageImport-empty {
  background: white;
}
.ant-empty {
  margin-top: 20px;
}
.drawer-bootom-button {
  border-top: 0px;
}
.ant-upload-list-item-name {
  position: none;
}
</style>
